"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.delete.confirm.title': '删除职业',
    'profession.delete.confirm.message': '确定要删除此职业吗？',
};
